<section class="landing-a__section landing-a__cta">
  <div class="landing-a__container landing-a__cta-inner">
    <h2>{{ 'landing.landing_1.cta.title' | translate }}</h2>
    <p>{{ 'landing.landing_1.cta.subtitle' | translate }}</p>
    <div class="landing-a__hero-actions landing-a__hero-actions--center">
      <a class="landing-a__btn landing-a__btn--primary landing-a__btn--lg" [href]="dashboardUrl()">
        {{ 'landing.landing_1.cta.primary' | translate }}
      </a>
      <a
        class="landing-a__btn landing-a__btn--secondary landing-a__btn--lg"
        href="#pricing"
        (click)="scrollToSection('pricing', $event)"
      >
        {{ 'landing.landing_1.cta.secondary' | translate }}
      </a>
    </div>
  </div>
</section>
